export const getWizardNavPrimaryLabel = (isFinalStep: boolean, isReactivate?: boolean): string => {
	if (isReactivate && isFinalStep) {
		return $.__('Reactivate Plan');
	}

	return isFinalStep ? $.__('Finish') : $.__('Next Step');
};

